import { hydrateRoot } from 'react-dom/client';

import { IReduxStore } from '../../../shared/types/redux';
import { IApplicationContext } from '../../../shared/types/applicationContext';
import { Application } from '../../../shared/containers/App';

interface IDependencies {
  store: IReduxStore;
  context: IApplicationContext;
}

export function renderApplication(dependencies: IDependencies) {
  const { store, context } = dependencies;
  const { config } = context;

  const projectName = config.getStrict<string>('projectName');
  const rootElement = document.getElementById(projectName);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  hydrateRoot(rootElement, <Application context={context} reduxStore={store} />);
}
